import React, { useEffect, useState } from 'react';
import TransactionViewModeStyles from './TransactionViewModeStyles';
import { TransactionFieldConfigStyles as AiTransactionFieldConfigStyles } from './ai/TransactionFieldConfig';
import { TransactionFieldConfigStyles as DrcTransactionFieldConfigStyles } from './cd/TransactionFieldConfig';
import { TransactionFieldConfigStyles as GyTransactionFieldConfigStyles } from './gy/TransactionFieldConfig';
import { TransactionFieldConfigStyles as BbTransactionFieldConfigStyles } from './bb/TransactionFieldConfig';
import { TransactionFieldConfigStyles as NaTransactionFieldConfigStyles } from './na/TransactionFieldConfig';
import { TransactionFieldConfigStyles as ZmTransactionFieldConfigStyles } from './zm/TransactionFieldConfig';
import type { Transaction } from '../../modules/Transactions';
import { useActiveProcedure } from '../../modules/Procedures';
import { isCountry } from '../../modules/User/utils';
import useOnlineStatus from '../../hooks/useOnlineStatus';
import CountryFieldset from './CountryFieldset';

interface Props {
  className?: string;
  transaction: Transaction;
  children: React.ReactNode;
}
const Fieldset: React.FC<Props> = ({ className, transaction, children }) => {
  const [disabled, setDisabled] = useState(false);
  const { procedure, isForQuery } = useActiveProcedure({ transactionLocalId: transaction.localId });
  const isOnline = useOnlineStatus();

  useEffect(() => {
    if (
      procedure?.activeStatus === undefined ||
      procedure?.activeStatus === 'Draft' ||
      isForQuery ||
      (procedure?.activeStatus === undefined && !isOnline)
    ) {
      setDisabled(false);
      return;
    }

    if (!procedure || procedure?.activeStatus !== 'Draft') {
      setDisabled(true);
    }
  }, [isOnline, procedure, setDisabled]);

  return (
    <div className={className} style={{ border: 0, margin: 0, padding: 0 }}>
      {/* @ts-ignore */}
      {<TransactionViewModeStyles disabled={disabled} />}
      {/* @ts-ignore */}
      <CountryFieldset />
      {children}
    </div>
  );
};

export default Fieldset;
